import React, {Component, Fragment} from 'react'
import {message, Upload} from 'antd'
import {baseUrl, reqFileList,} from '../../api';

export default class GnOrderDeliveryFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileListUpdate: [],
        }
    }

    componentDidMount() {
        this.getFileList(this.props.orderId)
    }

    getFileList = async (orderId) => {
        let po = {};
        po.orderId = orderId;
        po.objectType = this.props.fileType;
        po.pageNum = 1;
        po.pageSize = 10;
        const result = await reqFileList(po);
        if (result.code === 200) {
            result.data.rows = this.setFileUrl(result.data.rows);
            this.setState({fileListUpdate: result.data.rows});
        } else {
            message.error(result.message)
        }
    }

    setFileUrl = (fileList) => {
        (fileList || []).forEach((item, index) => {
            item.uid = index;
            item.name = item.fileName;
            item.status = 'done';
            item.url = baseUrl + '/' + item.filePath;
            item.thumbUrl = item.url;
        });
        return fileList;
    };

    render() {
        const {fileListUpdate} = this.state;
        const {fileType, orderId} = this.props;
        return (
            <Fragment>
                <Upload
                    showUploadList={{showDownloadIcon: false, showRemoveIcon: false}}
                    listType='picture-card'
                    fileList={fileListUpdate}
                >
                </Upload>
            </Fragment>
        )
    }
}